import { render } from "./NcrmOnboardingTemplateBasics.vue?vue&type=template&id=0f397ba0"
import script from "./NcrmOnboardingTemplateBasics.vue?vue&type=script&lang=js"
export * from "./NcrmOnboardingTemplateBasics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__